export const initialSettings = {
  facetsInput: 3,
  widthInput: 15,
  heightInput: 10,
  marginInput: 0,
  perspectiveInput: 80,
  originYInput: 80,
  zAxisInput: 0
};

export const names = [
  'facets',
  'width',
  'height',
  'margin',
  'perspective',
  'originY',
  'zAxis'
];

export const labels = [
  '# FACETS',
  'WIDTH - rem',
  'HEIGHT - rem',
  'MARGIN - rem',
  'PERSPECTIVE - rem',
  'Y ORIGIN - %',
  'Z AXIS -rem'
];

export const steps = [1, 5, 5, 2, 10, 5, 5];
